import { Image, ImageProps } from '@chakra-ui/react';
import { IMAGE_LAZY } from '@utils/constant';
import { FC, useState } from 'react';

interface IProps extends ImageProps {
  isLazy?: boolean;
}
const MyImage: FC<IProps> = ({ isLazy = true, ...props }) => {
  const [src, setSrc] = useState(props?.src);

  const handleError = () => {
    setSrc(IMAGE_LAZY);
  };

  return (
    <Image
      {...props}
      src={src || props?.src}
      fallbackSrc={IMAGE_LAZY}
      onError={handleError}
      {...(isLazy && {
        loading: 'lazy',
      })}
    />
  );
};

export default MyImage;
